import { defineMessages } from 'react-intl';
import type { LocalePerProduct } from 'contracts';

const topModels: LocalePerProduct = {
  livejasmin: {
    ...defineMessages({
      title: {
        id: 'pages.bestOf.topModels.livejasmin.title',
        defaultMessage: 'Top Models',
      },
      header: {
        id: 'pages.bestOf.topModels.livejasmin.header',
        defaultMessage: 'Top {numTopModels} Models',
      },
      subheader: {
        id: 'pages.bestOf.topModels.livejasmin.subheader',
        defaultMessage: 'Reach the Top {numTopModels}, enjoy extra exposure, and <b>boost your traffic!</b>',
      },
    }),
  },
  oranum: {
    ...defineMessages({
      title: {
        id: 'pages.bestOf.topModels.oranum.title',
        defaultMessage: 'Leaderboard',
      },
      header: {
        id: 'pages.bestOf.topModels.oranum.header',
        defaultMessage: 'Top Experts',
      },
      subheader: {
        id: 'pages.bestOf.topModels.oranum.subheader',
        defaultMessage:
          "We're giving up to <b>{monthlyAmount}</b> to our Top Experts every month! Connect with members to earn points and elevate your ranking!",
      },
    }),
  },
};

export default {
  pages: {
    bestOf: {
      topModels,
      periodFilter: {
        ...defineMessages({
          monthly: {
            id: 'pages.bestOf.periodFilter.monthly',
            defaultMessage: 'Monthly',
          },
          weekly: {
            id: 'pages.bestOf.periodFilter.weekly',
            defaultMessage: 'Weekly',
          },
          daily: {
            id: 'pages.bestOf.periodFilter.daily',
            defaultMessage: 'Daily',
          },
        }),
      },
    },
  },
};
